import { render, staticRenderFns } from "./fileInput.vue?vue&type=template&id=6066b874&"
import script from "./fileInput.vue?vue&type=script&lang=js&"
export * from "./fileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports